import common from './common';
import dnd from './dnd';

export default {
  common,
  dnd,
};
